export default {
  namespaced: true,
  state: {
    currentId: -1,
    stages: [
      {
        name: "メディアセンター",
        description: "図書館と情報教育センターの//機能を融合した施設。//",
        thumbnailImageSrc: "images/map/media_center.jpg",
        panoramicImageSrc: "images/360/360media_center.jpg",
        panoramicImageRotation: "-1.5 -60 -1",
        part: "head"
      },
      {
        name: "図書館",
        description: "約25万冊の図書と、//1,100種類の雑誌を所蔵する図書館。//",
        thumbnailImageSrc: "images/map/library.jpg",
        panoramicImageSrc: "images/360/360library.jpg",
        panoramicImageRotation: "-2 150 -1",
        part: "body"
      },
      {
        name: "次世代基盤技術研究所",
        description:
          "民間企業や行政機関と協力して、//研究開発に取り組むための////複合型施設。//",
        thumbnailImageSrc: "images/map/jisedai.jpg",
        panoramicImageSrc: "images/360/360jisedai.jpg",
        panoramicImageRotation: "-1.5 60 -1.5",
        part: "emptyBox1",
        extra: [
          {
            imageSrc: "images/extra/jisedai01.jpg",
            name: "ドライビング・シミュレータ",
            description:
              "自動車に関わる人間工学的課題を//解決するため//\n//快適性や安全性に関する////要素技術の研究開発を////行なっています。//"
          },
          {
            imageSrc: "images/extra/jisedai02.jpg",
            name: "金属3Dプリンタ",
            description:
              "金属粉末をレーザー照射して造形する//装置を導入し、////航空宇宙分野や////自動車分野などの////製品製造のための////研究開発を////行なっています。//"
          },
          {
            imageSrc: "images/extra/jisedai03.jpg",
            name: "水素ロータリエンジン計測ベンチ",
            description:
              "より効率的な水素ロータリエンジンの//開発をめざしています。//"
          }
        ]
      },
      {
        name: "杜cafe＋ku",
        description:
          "学生の憩いの場。//地域住民の方にも////自由にご利用いただける。//",
        thumbnailImageSrc: "images/map/cafe.jpg",
        panoramicImageSrc: "images/360/360cafe.jpg",
        panoramicImageRotation: "-1.5 -60 -1.5",
        part: "rightArm"
      },
      {
        name: "食堂",
        description:
          "栄養に配慮された、//安価で美味しい////メニューが勢ぞろい。//",
        thumbnailImageSrc: "images/map/shokudou.jpg",
        panoramicImageSrc: "images/360/360shokudou.jpg",
        panoramicImageRotation: "-2 -45 -1",
        part: "leftArm"
      },
      {
        name: "バスロータリー",
        description: "最寄り駅「西高屋駅」と「西条駅」への//アクセスが可能。//",
        thumbnailImageSrc: "images/map/rotary.jpg",
        panoramicImageSrc: "images/360/360rotary.jpg",
        panoramicImageRotation: "0 0 -0.5",
        part: "leg"
      },
      {
        name: "TERACO LAB. //Active Learning Area//",
        description:
          "共同学習スペースと、//大型のアクティブラーニング教室を////備えたエリア。//",
        thumbnailImageSrc: "images/map/teraco.jpg",
        panoramicImageSrc: "images/360/360teraco_lab.jpg",
        panoramicImageRotation: "-1.625 -45 -1.25",
        part: "emptyBox2"
      },
      {
        name: "グラウンド",
        description:
          "野球場、テニスコート、//400ｍトラック、サッカー場など////体を動かすための広大なグラウンド。//",
        thumbnailImageSrc: "images/map/ground.jpg",
        panoramicImageSrc: "images/360/360ground.jpg",
        panoramicImageRotation: "-4 30 -2",
        part: "bg"
      }
    ]
  },
  getters: {
    current(state, getters, rootState) {
      const id = state.currentId;
      const stage = id >= 0 ? state.stages[id] : null;
      if (stage) {
        let item = null;
        const item_id = rootState.magrobo[stage.part];
        if (item_id > 0) {
          if (rootState.parts.parts[stage.part]) {
            item = rootState.parts.parts[stage.part][item_id - 1];
          }
        }
        stage.item = item;
      }
      return stage;
    },
    stages(state, getters, rootState) {
      const stages = state.stages.concat();
      stages.forEach(stage => {
        let item = null;
        const item_id = rootState.magrobo[stage.part];
        if (item_id > 0) {
          if (rootState.parts.parts[stage.part]) {
            item = rootState.parts.parts[stage.part][item_id - 1];
          }
        }
        stage.item = item;
      });
      return stages;
    }
  },
  mutations: {
    current(state, id) {
      state.currentId = id - 1;
    }
  },
  actions: {
    enter({ getters, commit }, id) {
      commit("current", id);
      if (getters.current) {
        const part = getters.current.part;
        commit("parts/current", part, { root: true });
      }
    }
  }
};
